import { render, staticRenderFns } from "./CadastroStats.vue?vue&type=template&id=1d645437"
import script from "./CadastroStats.vue?vue&type=script&lang=js"
export * from "./CadastroStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports